import React, { useState } from "react";

const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
];

const timeOptions = [
    "06:00", "06:30", "07:00", "07:30",
    "08:00", "08:30", "09:00", "09:30",
    "10:00", "10:30", "11:00", "11:30",
    "12:00", "12:30", "13:00", "13:30",
    "14:00", "14:30", "15:00", "15:30",
    "16:00", "16:30", "17:00", "17:30",
    "18:00", "18:30", "19:00", "19:30",
    "20:00", "20:30", "21:00",
];

const defaultDay = {
    open: true,
    from: "09:00",
    to: "18:00",
};

const WorkingHours = ({ form, setForm }) => {
    const [lastActionState, setLastActionState] = useState(true);

    const workingHours = form.workingHours || {};

    const updateDay = (day, data) => {
        setForm((prev) => ({
            ...prev,
            workingHours: {
                ...prev.workingHours,
                [day]: {
                    open: true,
                    from: "09:00",
                    to: "18:00",
                    ...prev.workingHours?.[day],
                    ...data,
                },
            },
        }));
    };


    const toggleDay = (day) => {
        const current = workingHours?.[day]?.open ?? true;
        const newState = !current;

        setLastActionState(newState);

        updateDay(day, { open: newState });
    };


    // 🔥 APPLY MON-FRI BASED ON LAST ACTION
    const applyWeekdays = () => {
        const daysToApply = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

        const updated = { ...workingHours };

        daysToApply.forEach((day) => {
            updated[day] = {
                ...(updated[day] || {}),
                open: lastActionState,
            };
        });

        setForm((prev) => ({
            ...prev,
            workingHours: updated,
        }));
    };

    // 🔥 APPLY ALL DAYS BASED ON LAST ACTION
    const applyAllDays = () => {
        const updated = { ...workingHours };

        days.forEach((day) => {
            updated[day] = {
                ...(updated[day] || {}),
                open: lastActionState,
            };
        });

        setForm((prev) => ({
            ...prev,
            workingHours: updated,
        }));
    };


    return (
        <>
            {/* TOP BUTTONS */}
            <div className="flex flex-wrap gap-[8px]">
                <button
                    type="button"
                    onClick={applyWeekdays}
                    className="px-[14px] py-[8px] rounded-[8px] border text-[13px] font-semibold"
                >
                    Copy Mon to all weekdays
                </button>

                <button
                    type="button"
                    onClick={applyAllDays}
                    className="px-[14px] py-[8px] rounded-[8px] border text-[13px] font-semibold"
                >
                    Copy Mon to all days
                </button>
            </div>

            {/* HOURS */}
            <div className="bg-white rounded-[16px] border border-[#e4e5e7] overflow-hidden mt-[12px]">

                {days.map((day, index) => {
                    const data = workingHours?.[day] || defaultDay;

                    return (
                        <div
                            key={day}
                            className={`flex flex-col sm:flex-row sm:items-center gap-[8px] sm:gap-[16px] px-[20px] py-[14px] border-b border-[#f0f1f3] ${index === 6 ? "border-b-0" : ""}`}
                        >
                            {/* Day */}
                            <div className="w-[100px] shrink-0">
                                <span className="font-semibold text-[14px] text-[#212326]">
                                    {day}
                                </span>
                            </div>

                            {/* Toggle */}
                            <button
                                type="button"
                                onClick={() => toggleDay(day)}
                                className="flex items-center gap-[8px] shrink-0"
                            >
                                <div
                                    className={`w-[38px] h-[22px] rounded-full flex items-center px-[3px] transition-all ${data.open ? "bg-[#ff5323]" : "bg-[#e4e5e7]"
                                        }`}
                                >
                                    <div
                                        className={`w-[16px] h-[16px] rounded-full bg-white shadow-sm transition-transform ${data.open ? "translate-x-[16px]" : "translate-x-0"
                                            }`}
                                    />
                                </div>

                                <span className="font-medium text-[13px] text-[#212326]">
                                    {data.open ? "Open" : "Closed"}
                                </span>
                            </button>

                            {/* Time */}
                            {data.open && (
                                <div className="flex items-center gap-[8px] flex-1">
                                    <select
                                        value={data.from}
                                        onChange={(e) =>
                                            updateDay(day, { from: e.target.value })
                                        }
                                        className="h-[38px] rounded-[8px] border border-[#e4e5e7] px-[10px] font-semibold text-[13px] text-[#212326] bg-white appearance-none cursor-pointer focus:outline-none focus:border-[#ff5323]"
                                    >
                                        {timeOptions.map((t) => (
                                            <option key={t} value={t}>
                                                {t}
                                            </option>
                                        ))}
                                    </select>

                                    <span className="text-[13px] font-semibold text-[#9298a0]">to</span>

                                    <select
                                        value={data.to}
                                        onChange={(e) =>
                                            updateDay(day, { to: e.target.value })
                                        }
                                        className="h-[38px] rounded-[8px] border border-[#e4e5e7] px-[10px] font-semibold text-[13px] text-[#212326] bg-white appearance-none cursor-pointer focus:outline-none focus:border-[#ff5323]"
                                    >
                                        {timeOptions.map((t) => (
                                            <option key={t} value={t}>
                                                {t}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default WorkingHours;
